import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { ReactNode } from 'react';

interface CampaignOverviewSectionProps {
  id: string;
  label: string;
  badge?: ReactNode;
  children: ReactNode;
}

const CampaignOverviewSection = ({ id, label, badge, children }: CampaignOverviewSectionProps) => (
  <AgxSpacer gap="spacing-lg" style={{ minWidth: 0 }}>
    <AgxSpacer
      direction="horizontal"
      contentAlignment="center"
      gap="spacing-md"
      wrap
      style={{ minWidth: 0 }}
    >
      <AgxTypography id={`${id}-label`} type="body_ui" size="small" color="var(--text-tertiary)">
        {label}
      </AgxTypography>
      {badge}
    </AgxSpacer>
    {children}
  </AgxSpacer>
);

export default CampaignOverviewSection;
